exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app[data-v-26d7e7b9]{display:grid;height:100vh;width:100vw;position:relative}.fade-enter-active[data-v-26d7e7b9],.fade-leave-active[data-v-26d7e7b9]{-webkit-transition-property:opacity;transition-property:opacity;-webkit-transition-duration:.25s;transition-duration:.25s}.fade-enter-active[data-v-26d7e7b9]{-webkit-transition-delay:.25s;transition-delay:.25s}.fade-enter[data-v-26d7e7b9],.fade-leave-active[data-v-26d7e7b9]{opacity:0}", ""]);

// exports
